export default function validatePesel(pesel) {
    // Validate if PESEL is in the correct format (11 digits)
    if (!/^\d{11}$/.test(pesel)) {
        return { isValid: false, isUnder18: null };
    }

    // Extract the date of birth from PESEL
    const year = parseInt(pesel.substring(0, 2), 10);
    const month = parseInt(pesel.substring(2, 4), 10);
    const day = parseInt(pesel.substring(4, 6), 10);

    let fullYear;
    let fullMonth = month;

    // Determine the full year based on the PESEL encoding
    if (month > 80) {
        fullYear = 1800 + year;
        fullMonth -= 80;
    } else if (month > 60) {
        fullYear = 2200 + year;
        fullMonth -= 60;
    } else if (month > 40) {
        fullYear = 2100 + year;
        fullMonth -= 40;
    } else if (month > 20) {
        fullYear = 2000 + year;
        fullMonth -= 20;
    } else {
        fullYear = 1900 + year;
    }

    // Validate if the extracted date of birth is valid
    const birthDate = new Date(`${fullYear}-${fullMonth.toString().padStart(2, '0')}-${day.toString().padStart(2, '0')}`);
    if (
        birthDate.getFullYear() !== fullYear ||
        birthDate.getMonth() + 1 !== fullMonth ||
        birthDate.getDate() !== day
    ) {
        return { isValid: false, isUnder18: null };
    }

    // Validate PESEL checksum
    const weights = [1, 3, 7, 9, 1, 3, 7, 9, 1, 3];
    const checksum =
        10 -
        (pesel
            .split('')
            .slice(0, 10)
            .reduce((acc, digit, index) => acc + parseInt(digit, 10) * weights[index], 0) %
            10);

    if (checksum !== parseInt(pesel[10], 10)) {
        return { isValid: false, isUnder18: null };
    }

    // Check if the person is under 18
    const today = new Date();
    const age18Date = new Date(birthDate);
    age18Date.setFullYear(age18Date.getFullYear() + 18);

    const isUnder18 = today < age18Date;

    return { isValid: true, isUnder18 };
}
